import React from "react";
import type { Optional } from "../../../types";
import styles from "./menu-select-item.module.css";
import { classNames } from "../../../support/formatters/class-formatter";

export type MenuSelectItemProps = {
  className?: string;
  selectable?: Optional<boolean>;
  as?: "div" | "a";
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
} & React.HTMLAttributes<HTMLDivElement | HTMLAnchorElement>;

export function MenuSelectItem({
  className,
  selectable = true,
  children,
  as = "div",
  href,
  onClick,
  ...props
}: MenuSelectItemProps) {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (as === "a" && !href) {
      e.preventDefault(); 
    }
    onClick?.(e);
  };

  const Component = as;

  return (
    <Component
      className={classNames(styles.Container, className)}
      data-selectable={selectable}
      href={as === "a" ? href : undefined}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Component>
  );
}
